import { jsx as l } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#131317",
        fillRule: "evenodd",
        d: "m14.62 17.4-8.062-.037c-.52 0-1.175-.592-1.175-1.116l-.11-8.275a.517.517 0 0 0-.514-.518.5.5 0 0 0-.362.153L2.152 9.876A.52.52 0 0 0 2 10.24v5.605c0 2.68 2.155 4.854 4.815 4.854h5.565a.5.5 0 0 0 .362-.153l2.245-2.264a.518.518 0 0 0-.362-.888zM17.184 3.7H11.62a.5.5 0 0 0-.362.153L9.012 6.116a.518.518 0 0 0 .362.888l8.062.038c.52 0 1.175.592 1.175 1.116l.11 8.275c0 .285.23.518.514.518a.5.5 0 0 0 .362-.153l2.25-2.269a.52.52 0 0 0 .152-.364V8.559c0-2.68-2.155-4.854-4.815-4.854z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
